"use strict";
/* eslint-disable */
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
var _default = exports.default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M21.6 12.035C21.6 6.714 17.302 2.4 12 2.4s-9.6 4.314-9.6 9.635c0 4.519 3.1 8.31 7.28 9.352V14.98H7.702v-2.945h1.98v-1.268c0-3.28 1.479-4.8 4.687-4.8.608 0 1.657.12 2.086.24v2.668c-.226-.023-.62-.035-1.109-.035-1.574 0-2.182.598-2.182 2.154v1.041h3.136l-.539 2.945h-2.597v6.62c4.753-.576 8.437-4.639 8.437-9.565Z"
})), "0 0 24 24", "Facebook");